/**
 * @generated SignedSource<<78331f3a894a984811b189c15b173f64>>
 * @relayHash 42a591e8a503c18726719ce0e033115d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 01009bd4246e854f4c7dd37c83a00378424475f877271cd9bd767b390ddf4e6f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceContentRestrictionState = "EDIT_RESTRICTED" | "OPEN" | "RESTRICTED_BY_PARENT" | "VIEW_RESTRICTED" | "%future added value";
export type ConfluenceGroupUsageType = "ADMIN_OVERSIGHT" | "TEAM_COLLABORATION" | "USERBASE_GROUP" | "%future added value";
export type ConfluencePermission = "EDIT" | "SHARE" | "VIEW" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type useContentPermissionsQuery$variables = {
  cloudId: string;
  contentId: string;
};
export type useContentPermissionsQuery$data = {
  readonly confluence_contentPermissions: {
    readonly confluencePermissionsSummary: {
      readonly __typename: "ConfluencePermissionsSummary";
      readonly limit: number;
      readonly remainingSlots: number;
      readonly totalCount: number;
      readonly totalGroups: number;
      readonly totalTeams: number;
      readonly totalUsers: number;
    };
    readonly confluencePrincipalsConnection: {
      readonly __typename: "ConfluencePrincipalsConnection";
      readonly nodes: ReadonlyArray<{
        readonly avatar: string | null | undefined;
        readonly displayName: string;
        readonly effectivePermission: ConfluencePermission | null | undefined;
        readonly explicitPermission: ConfluencePermission;
        readonly hasSpaceEditPermission: boolean | null | undefined;
        readonly hasSpaceViewPermission: boolean | null | undefined;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly restrictingContent: {
          readonly id: string;
          readonly links: {
            readonly base: string | null | undefined;
            readonly webui: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly sitePermissionType: SitePermissionType | null | undefined;
        readonly usageType: ConfluenceGroupUsageType | null | undefined;
      } | null | undefined>;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      };
    };
    readonly contentId: string;
    readonly generalAccess: {
      readonly mode: ConfluenceContentRestrictionState | null | undefined;
    };
  } | null | undefined;
};
export type useContentPermissionsQuery = {
  response: useContentPermissionsQuery$data;
  variables: useContentPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ConfluenceContentPermissions",
    "kind": "LinkedField",
    "name": "confluence_contentPermissions",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluencePermissionsSummary",
        "kind": "LinkedField",
        "name": "confluencePermissionsSummary",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "limit"
          },
          {
            "kind": "ScalarField",
            "name": "remainingSlots"
          },
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "kind": "ScalarField",
            "name": "totalGroups"
          },
          {
            "kind": "ScalarField",
            "name": "totalTeams"
          },
          {
            "kind": "ScalarField",
            "name": "totalUsers"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluencePrincipalsConnection",
        "kind": "LinkedField",
        "name": "confluencePrincipalsConnection",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePrincipal",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "avatar"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "effectivePermission"
              },
              {
                "kind": "ScalarField",
                "name": "explicitPermission"
              },
              {
                "kind": "ScalarField",
                "name": "hasSpaceEditPermission"
              },
              {
                "kind": "ScalarField",
                "name": "hasSpaceViewPermission"
              },
              {
                "kind": "ScalarField",
                "name": "principalId"
              },
              {
                "kind": "ScalarField",
                "name": "principalType"
              },
              {
                "concreteType": "ConfluenceRestrictingContent",
                "kind": "LinkedField",
                "name": "restrictingContent",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "concreteType": "ConfluenceRestrictingContentLinks",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "base"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "webui"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "sitePermissionType"
              },
              {
                "kind": "ScalarField",
                "name": "usageType"
              }
            ]
          },
          {
            "concreteType": "ConfluencePageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          },
          (v1/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "concreteType": "ConfluenceContentGeneralAccess",
        "kind": "LinkedField",
        "name": "generalAccess",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "mode"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentPermissionsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentPermissionsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "42a591e8a503c18726719ce0e033115d",
    "id": "01009bd4246e854f4c7dd37c83a00378424475f877271cd9bd767b390ddf4e6f",
    "metadata": {},
    "name": "useContentPermissionsQuery",
    "operationKind": "query",
    "text": "query useContentPermissionsQuery($cloudId:ID!,$contentId:ID!){confluence_contentPermissions(cloudId:$cloudId,contentId:$contentId){confluencePermissionsSummary{limit,remainingSlots,totalCount,totalGroups,totalTeams,totalUsers,__typename},confluencePrincipalsConnection{nodes{avatar,displayName,effectivePermission,explicitPermission,hasSpaceEditPermission,hasSpaceViewPermission,principalId,principalType,restrictingContent{id,links{base,webui}},sitePermissionType,usageType},pageInfo{endCursor,hasNextPage},__typename},contentId,generalAccess{mode}}}"
  }
};
})();

(node as any).hash = "770c2eede7a1bb39a70384d70b5a9521";

export default node;
